export default [
    {
        path: 'parametrizacao',
        component: () => import(/* weimunizacaockChunkName: 'imunizacao-parametrizacao' */ '@/views/imunizacao/parametrizacao/Index'),
        redirect: 'parametrizacao/create',
        children: [
            {
                name: 'imunizacao-parametrizacao-create',
                path: 'create',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-parametrizacao' */ '@/views/imunizacao/parametrizacao/Form.vue'),
            },
        ],
    },
]